module.exports = __webpack_public_path__ + "img/companylogo.c9e17c4c.png";